import LegalPage from "./LegalPage";

export default function AboutUs() {
  return (
    <LegalPage
      title="About Us"
      subtitle="Built for Meesho sellers to reduce shipping charges and increase profit."
      sections={[
        {
          heading: "Who We Are",
          text: "ShipLess AI is an AI-powered image optimization tool made for Meesho sellers. Our goal is to help sellers reduce shipping charges by optimizing product images.",
        },
        {
          heading: "Our Mission",
          text: "We want to make selling on Meesho more profitable by helping sellers save money on every order.",
        },
        {
          heading: "Why ShipLess AI",
          text: "ShipLess AI checks multiple optimized image variations and helps sellers find the version with the lowest possible shipping charge.",
        },
        {
  heading: "Business Legal Name",
  text: "ShipLess AI is operated by GWALAX ONLINE SERVICES."
}
      ]}
    />
  );
}